import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ConsentGate from "./components/ConsentGate";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        {/* Inside the router because the banner links to /privacy. */}
        <ConsentGate pixelId={import.meta.env.VITE_META_PIXEL_ID} />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
